import React from 'react';
import {View} from 'react-native';
import {Image} from '@rneui/themed';
import {observer} from 'mobx-react-lite';

import {useWebScreenDimensions} from '../../../hooks/useWebScreenDimensions';
import {useStores} from '../../../stores/use-stores';
import { brandRewardsCopy } from '../../../utils/rewards';
import TitleLine from '../TitleLine';

type PromotionsProps = {
  onSeeAllPress?: () => void;
};

/**
 * Promotions static image for rewards tab
 */
function Promotions({onSeeAllPress}: PromotionsProps) {
  const {loyaltyInformationStore} = useStores();
  const {isWebDesktopScreen} = useWebScreenDimensions();

  const image = isWebDesktopScreen
    ? loyaltyInformationStore.information.RewardsPagePromotions.data
        ?.imageDesktop
    : loyaltyInformationStore.information.RewardsPagePromotions.data?.image;

  return (
    <View>
      <TitleLine title={brandRewardsCopy.promotionsTitle.toUpperCase()} onSeeAllPress={onSeeAllPress} />
      <Image
        onPress={onSeeAllPress}
        containerStyle={{
          width: '100%',
          aspectRatio: 1.54,
          flex: 1,
          borderRadius: 10,
          ...(isWebDesktopScreen ? {maxHeight: 400} : {}),
        }}
        source={{uri: image?.url}}
      />
    </View>
  );
}

export default observer(Promotions);
